import React from 'react';
import { Container } from '@mui/material';

function TermsOfService() {
    return <Container></Container>;
}

export default TermsOfService;
